export const navLinks = [
  { name: "All Products", path: "/products" },
  { name: "Orders", path: "/allorders" },
];

export const categories = [
  {
    name: "Men's Fashion",
    id: "6439d5b90049ad0b52b90048",
  },
  {
    name: "Women's Fashion",
    id: "6439d58a0049ad0b52b9003f",
  },
  { name: "Electronics", id: "6439d2d167d9aa4ca970649f" },
  { name: "Mobiles", id: "6439d2f467d9aa4ca97064a8" },
];
